// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"9f5e2f4e","971":"5c649641"}[chunkId] + ".chunk.js";
};